import { useList } from 'SharedDir/common/composables/useList';
import { PublicServiceApi } from 'SharedDir/backend/api';
import { useLoadingStore } from 'SharedDir/stores/loading.store';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { computed } from 'vue';

import { usePublicServicesFilters } from './usePublicServicesFilters';

// import { AdministrationServiceApi } from 'SharedDir/backend/api';
// import { columns } from 'AdminDir/modules/Services/services.service';
// import { computed, Ref, ref } from 'vue';
// import { useLoadingStore } from 'SharedDir/stores/loading.store';
// import { NServiceDesigner } from 'SharedDir/declarations/service-designer';

export function usePublicServicesList() {
  const {
    combinedParameters,
    fetch,
    list,
    paginationParams,
    filterParams,
    setQueryParams,
    // getQueryParams,
    clearParameters,
    defaultFilterParams,
    fillFromQueryString,
    fillFromQueryStringSsr,
  } = useList(usePublicServicesFilters, PublicServiceApi, true);

  const getShortServiceList = async () => {
    const params = {
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 0,
      sortBy: 'id',
      descending: false,
    };
    const { data: responseData } = await makeRequest(() => PublicServiceApi.getPaginated(params));
    return responseData;
  };

  const getServiceList = async (params) => {
    const { data: responseData } = await makeRequest(() => PublicServiceApi.getPaginated(params));
    return responseData;
  };

  return {
    fetch,
    paginationParams,
    filterParams,
    setQueryParams,
    // getQueryParams,
    clearParameters,
    list,
    getShortServiceList,
    defaultFilterParams,
    fillFromQueryString,
    fillFromQueryStringSsr,
  };
}
